import React from "react";
import moment from "moment";
import { Card, Container, Row, Col } from "react-bootstrap";
import "../home.scss";

export default function appointmentCard({ userDetails }) {
	const appointmentDetails = (userDetails) => {
		const date = moment(userDetails.user.appt_date).format("DD");
		const day = moment(userDetails.user.appt_date).format("dddd");
		let time = moment(userDetails.user.appt_date + "T" + userDetails.user.appt_time).format("h:mm a");
		time = time === "Invalid date" ? userDetails.user.appt_time : time;
		const monthAndYear = moment(userDetails.user.appt_date).format("MMMM YYYY");
		return (
			<Container className="appointment-message-container">
				<Row>
					<p className="title">Upcoming Appointment</p>
				</Row>
				<Row className="content-container">
					<Col>
						<Row className="date-day-time-row">
							<p className="date">{date}</p>
							<Col>
								<p className="day">{day.toUpperCase()}</p>
								<p className="time">{time.toUpperCase()}</p>
							</Col>
						</Row>
					</Col>
					<span className="nav-icon">
						<i className={`icon icon-calendar`} />
					</span>
				</Row>
				<Row>
					<p className="month-and-year">{monthAndYear}</p>
				</Row>
			</Container>
		);
	};

	const noAppointmentMessage = () => {
		return (
			<Container className="no-appointment-message-container">
				<Row className="icon-row">
					<span className="nav-icon">
						<i className={`icon icon-calendar`} />
					</span>
				</Row>
				<Row className="message-row">
					<p className="title">We miss you !</p>
					<p className="title">Call for an appointment</p>
				</Row>
			</Container>
		);
	};

	return (
		<Card className="card-1">
			<Card.Body className="card1-body">
				{userDetails.user.appt_date === null || userDetails.user.appt_time === null
					? noAppointmentMessage()
					: appointmentDetails(userDetails)}
			</Card.Body>
		</Card>
	);
}
